// extracted by mini-css-extract-plugin
module.exports = {"btn":"Scroll_btn__1xL1L","scroll":"Scroll_scroll__30OiP","img":"Scroll_img__2TqL8"};